import { render, staticRenderFns } from "./photo.vue?vue&type=template&id=c16b73d4&scoped=true&"
import script from "./photo.vue?vue&type=script&lang=js&"
export * from "./photo.vue?vue&type=script&lang=js&"
import style0 from "./photo.vue?vue&type=style&index=0&id=c16b73d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c16b73d4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c16b73d4')) {
      api.createRecord('c16b73d4', component.options)
    } else {
      api.reload('c16b73d4', component.options)
    }
    module.hot.accept("./photo.vue?vue&type=template&id=c16b73d4&scoped=true&", function () {
      api.rerender('c16b73d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/tpm/views/report_form/cancel_obtaining_evidence/photo.vue"
export default component.exports